import { render, staticRenderFns } from "./tech-analysis.vue?vue&type=template&id=8a369cd8&scoped=true&"
import script from "./tech-analysis.vue?vue&type=script&lang=js&"
export * from "./tech-analysis.vue?vue&type=script&lang=js&"
import style0 from "./tech-analysis.vue?vue&type=style&index=0&id=8a369cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a369cd8",
  null
  
)

export default component.exports